export const SET_BANNER_MESSAGES_SEEN = "SET_BANNER_MESSAGES_SEEN";